import { TableRow } from '@tiptap/extension-table';

export const ZyTableRow = TableRow.extend({
    allowGapCursor: false,
});
